// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__2XbQB","menu__container":"styles_menu__container__2Wm62","menu__link":"styles_menu__link__3EzM1","menu__link_delete":"styles_menu__link_delete__2EwAZ"};